import { SynchronizationEntity } from './synchronization-entity';

export class SynchronizationFrequencyConfiguration {
  constructor(public syncInterval: string, public retryInterval: string) {}

  syncIntervalInMilliseconds(): number {
    return this.convertToMilliseconds(this.syncInterval);
  }

  retryIntervalInMilliseconds(): number {
    return this.convertToMilliseconds(this.retryInterval);
  }

  private convertToMilliseconds(interval: string): number {
    let milliseconds = 0;
    const regex = /(\d+)([DHMS])/g;
    let match;

    while ((match = regex.exec(interval.toUpperCase())) !== null) {
      const value = parseInt(match[1]);
      const unit = match[2];

      switch (unit) {
        case 'D': {
          milliseconds += value * 86400000;
          break;
        }
        case 'H': {
          milliseconds += value * 3600000;
          break;
        }
        case 'M': {
          milliseconds += value * 60000;
          break;
        }
        case 'S': {
          milliseconds += value * 1000;
          break;
        }
      }
    }

    return milliseconds || parseInt(interval) * 1000;
  }
}

export class SynchronizationFrequencies {
  static readonly _frequencies = {
    [SynchronizationEntity.Teams]: new SynchronizationFrequencyConfiguration('30m', '5s'),
    [SynchronizationEntity.Shifts]: new SynchronizationFrequencyConfiguration('30m', '5s'),
    [SynchronizationEntity.Activities]: new SynchronizationFrequencyConfiguration('30m', '5s'),
    [SynchronizationEntity.Machines]: new SynchronizationFrequencyConfiguration('30m', '5s'),
    [SynchronizationEntity.Programmings]: new SynchronizationFrequencyConfiguration('30m', '5s'),
    [SynchronizationEntity.HarvestActivityReports]: new SynchronizationFrequencyConfiguration(
      '30m',
      '5s'
    ),
  };
}
